import {ThemeProvider} from '@mui/material/styles';
import {Box, CssBaseline, LinearProgress, StyledEngineProvider} from '@mui/material';
import config from './config';
import {useEffect, useState} from 'react';

// Entra ID (MSAL)
import {MsalProvider} from '@azure/msal-react';
import {PublicClientApplication} from '@azure/msal-browser';

// // routing
import Routes from 'app/routes';

// defaultTheme
import themes from 'themes';

// analytics
import {MatomoProvider, createInstance} from '@jonkoops/matomo-tracker-react';

// feature flags import {useFeatureFlag} from 'configcat-react';
import {useSelector} from 'react-redux';

import InactivityLogoutTimer from 'components/InactivityLogout/InactivityLogout';
// src/types/reduxTypes.d.ts
import {PersistState} from 'redux-persist/es/types';
import {RootState as BaseRootState} from './app/store'; // Adjust path to your store file
import {RouteTracker} from 'app/routes/RouteTracker';

interface RootState extends BaseRootState {
  _persist: PersistState;
}

const analyticsInstance = createInstance({
  urlBase: config.matomo.serverUrl,
  siteId: Number(config.matomo.siteId),
  linkTracking: false,
});

// ==============================|| APP ||============================== //
// Create MSAL instance
const msalInstance = new PublicClientApplication(config.entra.internal);

// Initialize MSAL instance
let isInitialized = false;
const initializeMsal = async () => {
  if (!isInitialized) {
    await msalInstance.initialize();
    isInitialized = true;
  }
};

const App = () => {
  const isHydrated = useSelector((state: RootState) => state._persist?.rehydrated);
  const [msalInitialized, setMsalInitialized] = useState(false);

  useEffect(() => {
    const initMsal = async () => {
      await initializeMsal();
      setMsalInitialized(true);
    };
    initMsal();
  }, []);

  if (isHydrated === false || !msalInitialized) {
    return (
      <ThemeProvider theme={themes()}>
        <Box sx={{pt: 10, width: '100%'}}>
          <LinearProgress color='secondary' />
        </Box>
      </ThemeProvider>
    );
  }
  return (
    <MsalProvider instance={msalInstance}>
      <MatomoProvider value={analyticsInstance}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={themes()}>
            <InactivityLogoutTimer />
            <RouteTracker />
            <CssBaseline />
            <Routes />
          </ThemeProvider>
        </StyledEngineProvider>
      </MatomoProvider>
    </MsalProvider>
  );
};

export default App;
